import { Data } from "@angular/router";
import { SimpleResponse } from "./genericResponse.model";

export interface CLPBilling {
  cLPCompanyID: number;
  cLPUserID: number;
  billingName: string;
  comments: string;
  useCC: boolean;
  pONumber: string;
  cCName: string;
  cCType: number;
  cCNumber: string;
  cCExMonth: number;
  cCExYear: number;
  cCCid: string;
  add1: string;
  add2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  feeSetup: number;
  feeCompany: number;
  feeUser: number;
  discountUser: number;
  feeMonthlyRider: number;
  feeSupportHour: number;
  feeAdditionalContacts: number;
  accountBalance: number;
  supportCredit: number;
  additionalContactsIncrements: number;
  cycleDay: number;
  contract: number;
  dtContractExpire: Date;
  dtNextBillDate: Date;
  dtPromoExpire: Date;
  isOnPromo: boolean;
  cLPVARID: number;
  status: number;
  dtCreated: Date;
  tmpCCName: string;
  tmpCCType: number;
  tmpCCNumber: string;
  tmpCCExMonth: number;
  tmpCCExYear: number;
  tmpCCCid: string;
  tmpAdd1: string;
  tmpAdd2: string;
  tmpCity: string;
  tmpState: string;
  tmpZip: string;
  tmpCountry: string;
  encCCNumber: string;
  tmpEncCCNumber: string;
  isSODigital: boolean;
  isSOProServ: boolean;
  engageBillingProfileID: number;
  engageBackupBillingProfileID: number;
  engageDigitalBillingProfileID: number;
  engageDigitalBackupBillingProfileID: number;
  engageProServBillingProfileID: number;
  engageProServBackupBillingProfileID: number;
  isSOCRM: boolean;
  monthlyFee: number;
  userCount: number;
}

export interface BillingDataResponse extends SimpleResponse {
  clpBilling: CLPBilling;
}

export interface CLPAddOnBilling {
  id: number;
  cLPCompanyID: number;
  perShortCodeTxtMsgPrice: bigint;
  perLongCodeTxtMsgPrice: bigint;
  perVoiceDropPrice: bigint;
  perLineLongCode: bigint;
  perLineCallForwarding: bigint;
  perLIneVoiceDrop: bigint;
  perLIneClickToCall: bigint;
  perLIneKMLMapCreation: bigint;
  perLIneVCR: bigint;
  perLongCodeMMSTxtMsgPrice: bigint;
  perUserAlertTxtMsgPrice: bigint;
  perLineVIP: bigint;
  perLineVirtualPhoneNumber: bigint;
}

export interface CLPAddOnBillingShow {
  id: number;
  cLPCompanyID: number;
  perShortCodeTxtMsgPrice: string;
  perLongCodeTxtMsgPrice: string;
  perVoiceDropPrice: string;
  perLineLongCode: string;
  perLineCallForwarding: string;
  perLIneVoiceDrop: string;
  perLIneClickToCall: string;
  perLIneKMLMapCreation: string;
  perLIneVCR: string;
  perLongCodeMMSTxtMsgPrice: string;
  perUserAlertTxtMsgPrice: string;
  perLineVIP: string;
  perLineVirtualPhoneNumber: string;
}

export interface BillingSummaryResponse extends SimpleResponse {
  accountBalance: number;
  maxContacts: number;
  feeAdditionalContacts: number;
  additionalContactsIncrements: number;
  supportCredit: number;
  feeSupportHour: number;
}

export interface AccountSummaryResponse extends SimpleResponse {
  accountBalance: string;
  maxContacts: string;
  feeAdditionalContacts: string;
  additionalContactsIncrements: string;
  supportCredit: string;
  feeSupportHour: string;
}
